import { Coordinate } from "ol/coordinate";
import { Boundary } from "./Boundary";
import { createContext } from "react";

interface BoundaryContextType {
  boundaries: Boundary[];
  selectedBoundary: Boundary | undefined;
  setSelectedBoundary: (boundary: Boundary | undefined) => void;
  overlayCoordinate: Coordinate | undefined;
  setOverlayCoordinate: (coord: Coordinate | undefined) => void;
  measurementMode: "km" | "mi";
  setMeasurementMode: (mode: "km" | "mi") => void;
  showLabels: boolean;
  setShowLabels: (show: boolean) => void;
}

export const BoundaryContext = createContext<BoundaryContextType | null>(null);
